// src/components/Preloader.jsx
import React, { useEffect, useState } from "react";
import logo from "../../assets/img/logo.png";
import loaderwhite from "../../assets/img/loader-white4.gif"; // Adjust the path as necessary
const Preloader = () => {
  const [loading, setLoading] = useState(true);
  const [deactivated, setDeactivated] = useState(false); // Simpler state for preloader hide

  useEffect(() => {
    // Simulate loading time
    const loadDataTimer = setTimeout(() => {
      setLoading(false); // Mark as loaded, then start deactivation sequence
    }, 2000); // Adjust this to your actual loading time

    return () => clearTimeout(loadDataTimer);
  }, []);

  useEffect(() => {
    if (!loading) {
      // Once loading is false, add the 'preloader-deactivate' class
      // This will trigger the curtain animation and loader fade out
      const deactivateTimer = setTimeout(() => {
        setDeactivated(true);
      }, 500); // Give a slight delay before curtains start closing

      // Completely remove the preloader after all transitions
      const removePreloaderTimer = setTimeout(() => {
        // The total transition time is 0.9s for curtains + 0.4s for loader fade,
        // so we wait slightly longer.
        setHideFinal(true); // A new state to completely hide component
      }, 500 + 900 + 400); // Delay + curtain transition + loader transition

      return () => {
        clearTimeout(deactivateTimer);
        clearTimeout(removePreloaderTimer);
      };
    }
  }, [loading]);

  // A separate state to completely unmount the component
  const [hideFinal, setHideFinal] = useState(false);
  if (hideFinal) {
    return null;
  }

  return (
    <div
      className={`preloader fixed inset-0 z-[99999] bg-transparent ${
        deactivated ? "preloader-deactivate" : ""
      }`}
    >
      {/* The .preloader .loader element - positioned exactly as in your CSS */}
      <div className="loader absolute top-[43%] left-0 right-0 -translate-y-[43%] text-center mx-auto w-[50px] h-[50px] transition-[opacity] duration-400 ease-in-out">
        <div className="shadow absolute top-[59px] left-0 w-full h-[5px] bg-black opacity-10 rounded-full animate-shadow-original"></div>
        <div className="box absolute top-0 left-0 w-full h-full bg-white rounded-[3px] animate-box-original">
          <img src={logo} className="w-full h-full object-contain" alt="logo" />
        </div>
      </div>

      {/* The loader_bg seems to be a separate full-screen loader, possibly with a different animation/purpose */}
      {/* If it should hide with the main preloader, its visibility needs to be tied to 'deactivated' as well. */}
      {/* Assuming it's meant to be visible until the main preloader deactivates. */}
      {/* If it also needs the '@keyframes loader' animation, that would go here. */}
      <div
        className={`loader_bg fixed inset-0 flex items-center justify-center bg-transparent ${
          deactivated ? "hidden" : ""
        }`}
      >
        {" "}
        {/* Hide it when main preloader deactivates */}
        {/* <div className="custom-loader">
          <img src={loaderwhite} alt="#" />
        </div> */}
      </div>
    </div>
  );
};

export default Preloader;
